export enum MaterialCatalogViewType {
  TILE = "tile view",
  LIST = "list view",
}
